// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSelfStudiesHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudyDTO from '../models/SelfStudyDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYear: number;
    secondaryProgramIdentifier: number | null | null;
    regionalPlanningPartnerId: number | null | null;
    districtId: string | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYear: 0,
            secondaryProgramIdentifier: null,
            regionalPlanningPartnerId: null,
            districtId: null,
        },
        initValues);
    },
    academicYear: 'academicYear',
    secondaryProgramIdentifier: 'secondaryProgramIdentifier',
    regionalPlanningPartnerId: 'regionalPlanningPartnerId',
    districtId: 'districtId',
}

interface Result extends ResultDTO {
    selfStudies: SelfStudyDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudies: [],
        },
        initValues);
    },
    selfStudies: 'selfStudies',
}

export { Request, Result };